import {useLayoutEffect} from 'react';
import {RouterProvider} from 'react-router-dom';
import EventBus from './providers/EventBus';

import {router} from './router/router';

import 'react-toastify/dist/ReactToastify.css';
import AuthContextProvider from './providers/AuthContextProvider';

function App() {
  useLayoutEffect(() => {
    const menu = localStorage.getItem('menu');
    if (typeof menu === 'string') {
      document.body.setAttribute('data-menu', menu);

      return;
    }

    document.body.setAttribute('data-menu', 'open');
    localStorage.setItem('menu', 'open');
  }, []);

  return (
    <EventBus>
      <AuthContextProvider>
        <RouterProvider router={router} />
      </AuthContextProvider>
    </EventBus>
  );
}

export default App;
